import React from "react";
import { Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import { TableModel } from "src/data/models/table-models/TableModel";
import { useDarkMode } from "src/context/DarkModeContext";

const { Title } = Typography;

interface PronounTableProps {
    tableData: TableModel;
}

const PronounTable: React.FC<PronounTableProps> = ({ tableData }) => {

    const { isDarkMode } = useDarkMode();

    if (!tableData || tableData.rows.length === 0 || tableData.headers.length === 0) {
        return null;
    }

    // Create columns dynamically from headers
    const columns: ColumnsType<any> = tableData.headers.map((header, index) => ({
        title: header,
        dataIndex: `col${index}`,
        key: `col${index}`,
        align: "center",
        className: "pronoun-header-cell",
        render: (text: string) => <span>{text}</span>,
    }));

    // Create data source for rows
    const dataSource = tableData.rows.map((row, rowIndex) => {
        const rowData: any = { key: rowIndex };
        row.forEach((cell, cellIndex) => {
            rowData[`col${cellIndex}`] = cell;
        });
        return rowData;
    });

    return (
        <div style={{ marginTop: 24, maxWidth: "850px", margin: "0 auto" }}>
            <Title level={4} style={{ color: isDarkMode ? "white" : "black", textAlign: "center", marginBottom: 16 }}>
                {tableData.title}
            </Title>
            <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                bordered
                size="middle"
            />
        </div>
    );
};

export default PronounTable;

